import {
  CircularProgress,
  FormHelperText,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material"
import { Control, Controller, FieldValues, Path } from "react-hook-form"

type PropertyFieldProps<TFieldValues extends FieldValues> = TextFieldProps & {
  control: Control<TFieldValues>
  name: Path<TFieldValues>
  additionalErrors?: string[]
  isLoading?: boolean
}
const PropertyField = <TFieldValues extends FieldValues>({
  control,
  name,
  additionalErrors,
  isLoading = false,
  ...props
}: PropertyFieldProps<TFieldValues>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <>
          <TextField
            size="small"
            fullWidth
            helperText={fieldState.error?.message}
            error={Boolean(fieldState.error)}
            InputLabelProps={{ shrink: true }}
            {...field}
            value={field.value ?? ""}
            {...props}
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <>
                  {isLoading && (
                    <InputAdornment position="end">
                      <CircularProgress size={16} />
                    </InputAdornment>
                  )}
                  {props.InputProps?.endAdornment}
                </>
              ),
            }}
          />
          {additionalErrors?.map((error, index) => (
            <FormHelperText key={`${error}-${index}`} error>
              - {error}
            </FormHelperText>
          ))}
        </>
      )}
    />
  )
}

export default PropertyField
